import React from 'react';

import Container from '@common/Container';
import Section from '@common/Section';
import Heading from '@common/Heading';
import Row from '@common/Row';
import Tile from '@common/blocks/list/resource-list/Tile';

const ResourceList = ({ data }) => {
  const {
    title,
    showTitle,
    list
  } = data;
  return (
    <Section>
      <Container>
        {(showTitle && title) &&
          <Row className='w-100 mx-auto py-3 border-top border-2 border-black'>
            <Heading type='h2'>{title}</Heading>
          </Row>
        }
        {list && list.map((resource, index) => (
          <Tile key={index} data={resource} />
        ))}
      </Container>
    </Section>
  )
}

export default ResourceList
